module.exports = __webpack_public_path__ + "static/media/go-logo-white.79d63f75.svg";